<div [formGroup]="immersionForm" *ngIf="immersionForm" class="parent-container">
    <div class="left-container">
        <div>
            <h4>Programme</h4>
        </div>
        <div>
            <p>Programme name</p>
            <input pInputText formControlName="programmeName" class="programme-name-input">
        </div>
        <div>
            <p>Programme details</p>
            <textarea pInputTextarea formControlName="programmeDetail" cols="34" rows="10"></textarea>
        </div>
    </div>
    <div class="middle-1-container">
        <div>
            <h4>Local coordinator</h4>
        </div>
        <div>
            <p>Name</p>
            <input pInputText formControlName="localCoordinatorName">
        </div>
        <div>
            <p>Local coordinator Phone number</p>
            <input pInputText formControlName="localCoordinatorPhone">
            <div class="global-warning" *ngIf="immersionForm.get('localCoordinatorPhone')!.touched && immersionForm.get('localCoordinatorPhone')!.errors!['invalidPhoneNumber']">
                Phone number not valid
            </div>
        </div>
        <div>
            <p>Local coordinator Phone 2</p>
            <input pInputText formControlName="localCoordinatorSecondPhone">
            <div class="global-warning"  *ngIf="immersionForm.get('localCoordinatorSecondPhone')!.touched && immersionForm.get('localCoordinatorSecondPhone')!.errors!['invalidPhoneNumber']">
                Phone number not valid
            </div>
        </div>
        <div>
            <p>Local coordinator Email</p>
            <input pInputText formControlName="localCoordinatorEmail" class="email-input">
        </div>
    </div>
    <div class="middle-2-container">
        <div>
            Partner Contact
        </div>
                <div>
            <p-dropdown placeholder="Select" [options]="schoolContactOptions" (onChange)="contactOptionChange()" formControlName="selectedContact"></p-dropdown>
        </div>
        <div *ngFor="let contact of selectedSchoolContacts">
            <p>Partner name</p>
            <p>{{contact.name}}</p>
            <p>Partner Phone number</p>
            <p>{{contact.phoneNumber}}</p>
            <p *ngIf="!contact.phoneNumber">/</p>
            <p>Partner Email</p>
            <p>{{contact.email}}</p>
            <p *ngIf="!contact.email">/</p>
            <p-button styleClass="p-button-danger" label="Delete" (onClick)="deleteContact(contact)"></p-button>
        </div>
        <div *ngFor="let form of contactFormArray.controls; let i = index">
            <div [formGroup]="form | formGroup">
                <div>
                    <div>
                        <p>
                            Type
                        </p>
                        <p-dropdown placeholder="---" [options]="schoolContactTypes" formControlName="contactType"
                            optionLabel="name"></p-dropdown>
                    </div>
                    <div>
                        <p>
                            Name
                        </p>
                        <input pInputText formControlName="contactName">
                    </div>
                </div>
                <div class="contact-form-item-container">
                    <div>
                        <p>
                            Email
                        </p>
                        <input pInputText formControlName="contactEmail" width="380">
                        <div class="global-warning"
                            *ngIf="form.get('contactEmail')!.touched && form.get('contactEmail')!.errors!['invalidEmail']">
                            Email not valid
                        </div>
                    </div>
                    <div>
                        <p>
                            Phone number
                        </p>
                        <input pInputText formControlName="contactPhoneNumber">
                        <div class="global-warning"
                            *ngIf="form.get('contactPhoneNumber')!.touched && form.get('contactPhoneNumber')!.errors!['invalidPhoneNumber']">
                            Phone number not valid
                        </div>
                    </div>
                </div>
                <p-button styleClass="p-button-danger" label="Delete" (onClick)="deleteContactForm(form)"></p-button>
            </div>
        </div>
        <p-button label="add custom contact" (onClick)="addSchoolContactForm()"></p-button>
    </div>
    <div class="right-container">
        <div>
            <h4>Organisation</h4>
        </div>
        <div>
            <p>Organisation name</p>
            <input pInputText formControlName="activityCenterName">
        </div>
        <div>
            <p>Organisation address</p>
            <input pInputText formControlName="activityCenterAddress" class="address-input">
        </div>
        <div>
            <p>Organisation email</p>
            <input pInputText formControlName="activityCenterEmail" class="email-input">
        </div>
        <div>
            <p>Organisation phone</p>
            <input pInputText formControlName="activityCenterPhone">
        </div>
    </div>
</div>